import React, { PropsWithChildren } from 'react';
import { PageHeaderContainerStyles } from "./page-header-container-styles";

export const PageHeaderContainer = ({children}: PropsWithChildren<{}>) => {
    const classes = PageHeaderContainerStyles();
    
    return (
        <div className={classes.headerContainer}>
            {children}
        </div>
    );
}
